import React, { useState } from 'react';
import { Plus, Search, Mail, Phone, MapPin, Euro, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const mockBrands = [{
  id: 1,
  name: 'Luxury Fashion Brand',
  category: 'Fashion',
  contact: 'contact@luxurybrand.com',
  phone: '+39 02 1234567',
  interests: ['Retail', 'Boutique'],
  status: 'Attivo',
  budget: '800k-1M',
  location: 'Milano Centro'
}, {
  id: 2,
  name: 'Premium Lifestyle Co.',
  category: 'Lifestyle',
  contact: 'info@premiumlifestyle.com',
  phone: '+39 02 7654321',
  interests: ['Showroom', 'Retail'],
  status: 'Attivo',
  budget: '1M-1.5M',
  location: 'Quadrilatero'
}, {
  id: 3,
  name: 'Design Studio Milano',
  category: 'Design',
  contact: 'hello@designstudio.it',
  phone: '+39 02 9876543',
  interests: ['Showroom'],
  status: 'In Attesa',
  budget: '600k-800k',
  location: 'Brera'
}, {
  id: 4,
  name: 'Elite Fashion Group',
  category: 'Fashion',
  contact: 'info@elitefashion.com',
  phone: '+39 02 5551234',
  interests: ['Boutique', 'Retail'],
  status: 'Attivo',
  budget: '850k-1.2M',
  location: 'Via della Spiga'
}, {
  id: 5,
  name: 'Accessories Boutique',
  category: 'Accessori',
  contact: 'contact@accessories.it',
  phone: '+39 02 7778899',
  interests: ['Boutique'],
  status: 'Attivo',
  budget: '600k-750k',
  location: 'Montenapoleone'
}, {
  id: 6,
  name: 'Furniture Luxury',
  category: 'Arredamento',
  contact: 'info@furniturelux.com',
  phone: '+39 02 3334455',
  interests: ['Showroom'],
  status: 'Attivo',
  budget: '1.1M-1.3M',
  location: 'Tortona'
}, {
  id: 7,
  name: 'Fashion Concept Store',
  category: 'Fashion',
  contact: 'hello@fashionconcept.it',
  phone: '+39 02 6667788',
  interests: ['Retail', 'Boutique'],
  status: 'Attivo',
  budget: '650k-800k',
  location: 'Corso Como'
}, {
  id: 8,
  name: 'Luxury Jewelry',
  category: 'Gioielli',
  contact: 'contact@luxuryjewelry.com',
  phone: '+39 02 9998877',
  interests: ['Boutique'],
  status: 'In Attesa',
  budget: '700k-900k',
  location: 'Via Montenapoleone'
}, {
  id: 9,
  name: 'Urban Lifestyle Brand',
  category: 'Lifestyle',
  contact: 'info@urbanlifestyle.it',
  phone: '+39 02 4445566',
  interests: ['Retail', 'Showroom'],
  status: 'Attivo',
  budget: '500k-700k',
  location: 'Isola'
}, {
  id: 10,
  name: 'Premium Design House',
  category: 'Design',
  contact: 'contact@premiumdesign.com',
  phone: '+39 02 2223344',
  interests: ['Showroom'],
  status: 'Attivo',
  budget: '900k-1.1M',
  location: 'Porta Nuova'
}, {
  id: 11,
  name: 'Boutique Fashion Italia',
  category: 'Fashion',
  contact: 'info@boutiquefashion.it',
  phone: '+39 02 8889999',
  interests: ['Boutique'],
  status: 'Attivo',
  budget: '550k-700k',
  location: 'San Babila'
}, {
  id: 12,
  name: 'Contemporary Art Gallery',
  category: 'Arte',
  contact: 'gallery@contemporary.com',
  phone: '+39 02 1112233',
  interests: ['Showroom', 'Retail'],
  status: 'In Attesa',
  budget: '800k-1M',
  location: 'Brera'
}, {
  id: 13,
  name: 'Luxury Watches & Jewelry',
  category: 'Gioielli',
  contact: 'info@luxurywatches.it',
  phone: '+39 02 5556677',
  interests: ['Boutique'],
  status: 'Attivo',
  budget: '1M-1.5M',
  location: 'Montenapoleone'
}, {
  id: 14,
  name: 'Home Decor Premium',
  category: 'Arredamento',
  contact: 'contact@homedecor.com',
  phone: '+39 02 7778888',
  interests: ['Showroom', 'Retail'],
  status: 'Attivo',
  budget: '700k-900k',
  location: 'Tortona'
}, {
  id: 15,
  name: 'Street Fashion Brand',
  category: 'Fashion',
  contact: 'info@streetfashion.it',
  phone: '+39 02 3334444',
  interests: ['Retail'],
  status: 'In Attesa',
  budget: '400k-600k',
  location: 'Corso Buenos Aires'
}];
export function Brands() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const filteredBrands = mockBrands.filter(brand => brand.name.toLowerCase().includes(searchTerm.toLowerCase()) || brand.category.toLowerCase().includes(searchTerm.toLowerCase()) || brand.location.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="space-y-6" data-id="element-411">
      <div className="flex items-center justify-between" data-id="element-412">
        <div data-id="element-413">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-414">
            Gestione Brand
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-415">
            {mockBrands.length} brand totali
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-416">
          <Plus className="w-4 h-4" data-id="element-417" />
          Nuovo Brand
        </button>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-418">
        <div className="relative" data-id="element-419">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-420" />
          <input type="text" placeholder="Cerca brand per nome, categoria, location..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-421" />
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-422">
        <div className="overflow-x-auto" data-id="element-423">
          <table className="w-full min-w-[1000px]" data-id="element-424">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-425">
              <tr data-id="element-426">
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-427">
                  Brand
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-428">
                  Categoria
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-429">
                  Location Preferita
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-430">
                  Budget
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-431">
                  Interessi
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-432">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-433">
              {filteredBrands.map(brand => <tr key={brand.id} onClick={() => navigate(`/brands/${brand.id}`)} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-434">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-435">
                    <p className="text-sm font-normal text-gray-900" data-id="element-436">
                      {brand.name}
                    </p>
                    <div className="flex items-center gap-2 mt-1 text-xs text-gray-500" data-id="element-437">
                      <Mail className="w-3 h-3" data-id="element-438" />
                      <span data-id="element-439">{brand.contact}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-440">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs font-normal rounded-full" data-id="element-441">
                      {brand.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-442">
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-443">
                      <MapPin className="w-3 h-3" data-id="element-444" />
                      <span data-id="element-445">{brand.location}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-446">
                    <div className="flex items-center gap-2 text-sm text-gray-900" data-id="element-447">
                      <Euro className="w-3 h-3" data-id="element-448" />
                      <span data-id="element-449">{brand.budget}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-450">
                    <div className="flex gap-2" data-id="element-451">
                      {brand.interests.map(interest => <span key={interest} className="px-2 py-1 bg-[#1388ad]/10 text-[#1388ad] text-xs font-normal rounded-full" data-id="element-452">
                          {interest}
                        </span>)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-453">
                    <span className={`px-2 py-1 text-xs font-normal rounded-full ${brand.status === 'Attivo' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-454">
                      {brand.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}